import { useState } from 'react';

import { Card, CardBody } from '@apigrowfinance/pbolt-card';
import { ChipButton } from '@apigrowfinance/pbolt-chip-button';
import { Restricted } from '@apigrowfinance/pbolt-permission-provider';
// eslint-disable-next-line import/no-unresolved
import { Notify } from 'notify/services/Notify';
import { useIntl } from 'react-intl';

import { useAccount } from '@contexts/AccountProvider';
import useGetCustomerDetails from '@hooks/queries/useGetCustomerDetails';
import { REGULAR_IN_REM } from '@pages/accountDetail/tabs/consts';
import UserEditModal from '@pages/accountDetail/tabs/users/user/userEditModal/UserEditModal';
import UserRow from '@pages/accountDetail/tabs/users/user/UserRow';
import getEnumTranslation from '@utils/getEnumTranslation';

type UserProps = {
    customerId: number;
    onRefetch?: () => void;
    isLoading?: boolean;
};

const UserRowContainer = ({
    customerId,
    onRefetch,
    isLoading = false,
}: UserProps) => {
    const { data, isLoading: isLoadingCustomer } = useGetCustomerDetails({
        customerId,
    });
    const { refetch } = useAccount();
    const [userEditModalSetOpen, setUserEditModalSetOpen] = useState(false);

    const { formatMessage } = useIntl();
    const notify = Notify.getInstance();
    const isLoadingAny = isLoading || isLoadingCustomer;

    const handleOnClickEdit = () => {
        setUserEditModalSetOpen(true);
    };

    const handleOnClickClose = () => {
        setUserEditModalSetOpen(false);
    };

    const handleOnClickSaved = () => {
        setUserEditModalSetOpen(false);
        refetch.accountRefetch();
        notify.addNotification(
            formatMessage(
                {
                    id: 'UserRowContainer.success',
                    defaultMessage:
                        'You’ve successfully updated {customer} details.',
                },
                {
                    customer:
                        data?.customer?.nickname ||
                        data?.customer?.social_name ||
                        '',
                },
            ),
        );
        onRefetch();
    };
    return (
        <>
            <Card
                isTopRadiusBorder={false}
                isBottomRadiusBorder={false}
                isGap={false}>
                {/*min-height header for chips*/}
                <CardBody
                    direction="row"
                    minHeight={REGULAR_IN_REM}
                    sx={{ justifyContent: 'end' }}>
                    <Restricted to="edit.customer">
                        <ChipButton
                            onClick={handleOnClickEdit}
                            label={getEnumTranslation('edit')}
                            variant="editMenu"
                            isLoading={isLoadingAny}
                            bordered
                        />
                    </Restricted>
                </CardBody>
                <UserRow userDetails={data} isLoading={isLoadingAny} />
            </Card>
            {userEditModalSetOpen && (
                <UserEditModal
                    customerDetails={data}
                    onClickClose={handleOnClickClose}
                    onClickSave={handleOnClickSaved}
                />
            )}
        </>
    );
};

export default UserRowContainer;
